import React from "react";

import { StyledTable } from "../../components/tables/styledComponents";

import {
  STEWARDSHIP_SCREENER_PAGE_SIZE,
  VOTING_SCREENER_COLUMN_TYPES,
} from "./constants";
import { TABLE_BASE_HEIGHT } from "../../styles";
import {
  CellType,
  VotingCompanySummaryDataSource,
} from "../../models/tableModels";
import { CustomTableCell } from "../../components/tables/CustomTableCell";
import { PaginationParams } from "../../types/ScreenerTypes";
import { getColumnTypeFromKeyOrValue } from "./utils";
import { ColumnType } from "antd/es/table";
import { TableChangeParams } from "../../hooks/useVotingAlignment";
import { SorterResult } from "antd/es/table/interface";

export const VotingSummaryTable: React.FC<{
  data: VotingCompanySummaryDataSource[];
  isLoading: boolean;
  totalRecords: number;
  handleTableChange: (tableParams: TableChangeParams) => void;
  pagination: PaginationParams;
  sorter: SorterResult<VotingCompanySummaryDataSource>;
  columns: ColumnType<VotingCompanySummaryDataSource>[];
}> = ({
  data,
  totalRecords,
  isLoading,
  pagination,
  sorter,
  handleTableChange,
  columns,
}) => {
  return (
    <>
      <StyledTable
        key={data.length ? data[0].key : "empty"}
        isLoading={isLoading}
        dataSource={data.length ? data : []}
        hasEveryCellBorderBottom={true}
        scroll={{ y: TABLE_BASE_HEIGHT, x: "max-content" }}
        pagination={{
          pageSize: STEWARDSHIP_SCREENER_PAGE_SIZE,
          total: totalRecords,
          showSizeChanger: false,
          current: pagination?.page,
          showTotal: (total, range) =>
            `Showing ${range[0]}-${range[1]} of ${total} records`,
        }}
        onChange={(pagination, filters, sorter): void => {
          handleTableChange({
            pagination: {
              page: pagination.current || 1,
              page_size: pagination.pageSize || 20,
            },
            filters,
            sorter: sorter as SorterResult<VotingCompanySummaryDataSource>,
          });
        }}
      >
        {columns.map((column) => (
          <StyledTable.Column
            key={column.key}
            dataIndex={column.dataIndex}
            title={column.title}
            fixed={column.fixed}
            filters={column.filters}
            filteredValue={column.filteredValue}
            sorter={column.sorter ? true : false}
            sortOrder={
              sorter.field === column.dataIndex ? sorter.order : undefined
            }
            render={(value: CellType): JSX.Element => (
              <CustomTableCell
                value={value}
                type={
                  getColumnTypeFromKeyOrValue(
                    column.key as string,
                    value,
                    VOTING_SCREENER_COLUMN_TYPES,
                    isLoading
                  ).type
                }
              />
            )}
          />
        ))}
      </StyledTable>
    </>
  );
};
